const columns = [
  {
    title: "商品名称",

    dataIndex: "GoodsName",
    slots: { customRender: "goods_name" },
  },
  // {
  //   title: "商品链接",

  //   align: "left",
  //   slots: { customRender: "url" },
  //   width: 110,
  // },
  {
    title: "SPU编号",
    dataIndex: "GoodsSPU",
    slots: { customRender: "goods_SPU" },
    width: 200,
  },
  // {
  //   title: "支付宝平台测商品ID",
  //   dataIndex: "GoodsId",
  //   slots: { customRender: "goods_Id" },
  //   //  width: 115,
  // },
  // {
  //   title: "小程序名称",
  //   dataIndex: "XCXName",
  //   slots: { customRender: "XCX_Name" },
  //   width: 115,
  // },
  {
    title: "商品分类",
    dataIndex: "GoodsType",
    slots: { customRender: "goods_Type" },
    width: 115,
  },
  {
    title: "操作",
    slots: { customRender: "operate" },
    width: 250,
  },
  // {
  //   title: "状态",
  //   dataIndex: "StatusStr",
  //   slots: { customRender: "status_str" },
  //   width: 83,
  // },
];

export default {
  columns,
};
